import axios from "axios";
import { api } from "./api_route";

export const createCaseDoc = async (caseID, formData) => {
  return await axios.post(
    `${api}/cd_caseDocs/createCaseDocs/${caseID}`,
    formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    },
  );
};

export const createBulkCaseDocument = async (formData, onUploadProgress) => {
  try {
    return await axios.post(`${api}/cd_caseDocs/bulkUpload`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress,
    });
  } catch (error) {
    console.error("createBulkCaseDocument failed:", error);
    throw error;
  }
};
export const getCaseDocuments = async (caseID) => {
  try {
    const response = await axios.get(`${api}/cd_caseDocs/caseDocs/${caseID}`);
    return response.data;
  } catch (error) {
    console.error("getCaseDocuments failed:", error);
    throw error;
  }
};

export const updateCaseDoc = async (caseDocId, formData) => {
  return await axios.put(
    `${api}/cd_caseDocs/updateCaseDocs/${caseDocId}`,
    formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    },
  );
};

export const deleteCaseDoc = async (caseDocId) => {
  return await axios.delete(`${api}/cd_caseDocs/deleteCaseDocs/${caseDocId}`);
};

export const caseDocumentDownload = async (values) => {
  try {
    const response = await axios.get(
      `${api}/documents/caseDocs/${values.original.documentNewName}`,
      {
        responseType: "blob",
      },
    );
    return response.data;
  } catch (error) {
    console.error("Download failed:", error);
    throw error;
  }
};

export const deleteBulkCaseDocs = async (caseDocIds) => {
  return await axios.post(`${api}/cd_caseDocs/deleteBulkCaseDocs`, {
    caseDocIds,
  });
};

export const rollbackBatch = async (caseDocIds) => {
  return await axios.post(`${api}/cd_caseDocs/rollback-batch`, { caseDocIds });
};

export const sendCaseDocumentsEmailAPI = async (formData) => {
  try {
    const response = await axios.post(`${api}/cd_caseDocs/sendEmail`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    console.error("sendCaseDocumentsEmailAPI failed:", error);
    throw error;
  }
};
